import { useState } from 'react';
import clsx from 'clsx';
import DropdownButton from 'components/Button/DropdownButton/DropdownButton';
import APResponsiveDropdown from 'components/Dropdown/APResponsiveDropdown';
import DeleteConfirmation from 'components/DeleteConfirmation';

const DocumentOptions = ({
    onPreview,
    onView,
    onDelete,
    showDelete = true,
    confirmMessage= 'Are you sure you want to delete this document?',
    confirmText,
    requireConfirmation,
    viewers = [],
    viewToken,
    documentKind,
  }) => {
  const [opened, setOpened] = useState(false);
  const [deleteConfirmOpened, setDeleteConfirmOpened] = useState(false);
  const [previewSubmenuOpened, setPreviewSubmenuOpened] = useState(false);

  const show = () => {
    setOpened(true);
  };

  const dismiss = () => {
    setOpened(false);
  };

  const removeDocument = () => {
    onDelete();
    setDeleteConfirmOpened(false);
  };

  const isQuestionnaire = documentKind === 'questionnaire';
  const isInvoice = documentKind === 'invoice';
  const isQuote = documentKind === 'quote';
  // We don't show previews for questionnaires only. Must have a view token.
  const shouldShowPreview = !isQuestionnaire && viewToken || isInvoice || isQuote;
  const hasViewers = documentKind === 'questionnaire' && viewers.length > 0;

  const handlePreviewClick = () => {
    if (isInvoice || isQuote) {
      if (viewToken) {
        onView(viewToken);
      } else {
        onPreview();
      }
    } else if (viewToken) {
      onPreview(viewToken);
    }
    dismiss();
  };

  const handleViewDocumentClick = (_viewToken) => {
    onView(_viewToken);
  };

  const togglePreviewSubmenu = (e) => {
    e.stopPropagation();
    setPreviewSubmenuOpened(!previewSubmenuOpened);
  };

  const renderPreviewButton = () => {
    if (hasViewers) {
      return (
        <div className="button--menu-with-submenu">
          <button
            className={clsx(
              'button--unstyled',
              'button--menu',
              'button--menu-parent',
            )}
            onClick={togglePreviewSubmenu}
          >
            Preview & Print
            <span className={clsx('fa fa-chevron-down submenu-arrow', previewSubmenuOpened && 'opened')} />
          </button>

          {previewSubmenuOpened && (
            <div className="button--menu-submenu">
              {viewers.map((viewer) => (
                <button
                  key={viewer.id}
                  className={clsx(
                    'button--unstyled',
                    'button--menu',
                    'button--menu-child',
                  )}
                  onClick={() => handleViewDocumentClick(viewer.viewToken)}
                >
                  {viewer.toBeViewedByName}
                </button>
              ))}
            </div>
          )}
        </div>
      );
    }
    if (!shouldShowPreview) return null;
    return (
      <button
        className={clsx(
          'button--unstyled',
          'button--menu',
        )}
        onClick={() => handlePreviewClick()}
      >
        Preview & Print
      </button>
    );
  };

  const renderOptions = () => {
    const handleDelete = () => {
      setDeleteConfirmOpened(true);
      dismiss();
    };

    return (
      <>
        {renderPreviewButton()}
        {showDelete && (
          <button
            className={clsx(
              'button--unstyled',
              'button--menu',
            )}
            onClick={handleDelete}
          >
            Delete
          </button>
        )}
      </>
    );
  };

  const trigger = (
    <DropdownButton className="button--unstyled button--options">
      <span className="fa fa-ellipsis-v" />
    </DropdownButton>
  );

  return (
    <>
      <APResponsiveDropdown
        opened={opened}
        show={show}
        dismiss={dismiss}
        triggerButton={trigger}
        placement="bottom-end"
        menuClass="document-options-dropdown"
      >
        {renderOptions()}
      </APResponsiveDropdown>

      <DeleteConfirmation
        show={deleteConfirmOpened}
        handleClose={() => {
          setDeleteConfirmOpened(false);
        }}
        handleConfirm={removeDocument}
        deleteText="Delete"
        confirmText={confirmText}
        size="xs"
        requireConfirmation={requireConfirmation}
      >
        <p>
          {confirmMessage}
        </p>
      </DeleteConfirmation>
    </>
  );
};

export default DocumentOptions;
